export const QUIZ_TOTAL = 4;
/**
 * All questions are tap-to-select (no typing) — mirrors the higher-converting
 * audit funnel. Numeric questions map each range to a representative midpoint
 * so the markup math in `computeQuiz` is unchanged.
 */
export const QUIZ_QUESTIONS = [
    {
        id: 'workers',
        number: 1,
        title: 'How many workers have you hired through an agency lately?',
        helper: 'Temp, contract, or permanent — in the last 3 months.',
        options: [
            { id: 'A', label: '1–5 workers', value: 3 },
            { id: 'B', label: '6–15 workers', value: 10 },
            { id: 'C', label: '16–40 workers', value: 25 },
            { id: 'D', label: '40+ workers', value: 55, insight: "That's serious agency volume — let's see what it's costing you." },
        ],
    },
    {
        id: 'wage',
        number: 2,
        title: 'What do those workers earn per hour?',
        helper: 'Their actual wage — not what the agency bills you.',
        options: [
            { id: 'A', label: '$12–15 / hr', value: 13.5 },
            { id: 'B', label: '$15–18 / hr', value: 16.5 },
            { id: 'C', label: '$18–22 / hr', value: 20 },
            { id: 'D', label: '$22+ / hr', value: 25 },
        ],
    },
    {
        id: 'markup',
        number: 3,
        title: 'What markup does your agency add on top?',
        helper: 'Industry standard is 25–40%. Most owners are never told this number.',
        options: [
            { id: 'A', label: 'Around 20–25%', sub: 'Lower end — still adds up fast.', value: 'A' },
            { id: 'B', label: 'Around 30–40%', sub: 'Industry standard — $5–6 extra per hour.', value: 'B' },
            { id: 'C', label: "Not sure / they won't say", sub: "We'll use the 30% industry average.", value: 'C' },
            { id: 'D', label: 'More than 40%', sub: 'Above average — your number will be eye-opening.', value: 'D', insight: 'Over 40% markup — you could be badly overpaying.' },
        ],
    },
    {
        id: 'hrsPerWeek',
        number: 4,
        title: 'How many hours a week do they work?',
        helper: 'Roughly — full-time is 40, part-time is around 20.',
        options: [
            { id: 'A', label: 'Part-time (~20 hrs)', value: 20 },
            { id: 'B', label: 'Mostly full-time (~32 hrs)', value: 32 },
            { id: 'C', label: 'Full-time (40 hrs)', value: 40 },
            { id: 'D', label: 'Overtime (45+ hrs)', value: 47 },
        ],
    },
];
